import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  msgAlignment: {
    border: `1px solid ${'#FF0404'}`, //`1px solid ${theme.palette.error}`,
    marginTop: '100px',
    borderRadius: '16px',
    backdropFilter: 'blur(8px)',
    "& .MuiPaper-root": {
      display: 'flex',
      justifyContent: 'center',
      background: 'rgba(255, 4, 4, 0.4)',
      borderRadius: '16px',
      color: '#FFFFFF',
      letterSpacing: '0.08em',
    },
    "& .MuiTypography-root": {
      fontWeight: 700,
    }
  },
}));